import {
  getMdHeadingId,
  isAbsoluteUrl,
  parseQueryString,
} from '../../../../utils/locationUtils';
import {
  removeBreakingSpaces,
  removeHtmlFromTxt,
} from '../../../../utils/markdownUtils';
import { toUrlFormat } from '../../../../utils/treeVisitors';

const removeSpecialChars = (str = '') =>
  str.replace(/[`~!@#$%^&*()|+=?;:'",.<>{}[\]\\/]/gi, '');

export const getHeadingText = (props) => {
  let headingText = '';
  if (props && props.children && props.children.length > 0) {
    if (typeof props.children === 'string') {
      headingText += props.children;
    } else {
      props.children.forEach((child) => {
        if (
          child.type === 'parsedHtml' ||
          (child.key && child.key.startsWith('parsedHtml')) ||
          child.children ||
          (child.props && child.props.children)
        ) {
          const parsedHtmlChildProps = child.props
            ? {
                element: child.props.element,
                children: child.props.children,
                value: child.props.value,
                type: child.type,
              }
            : {
                element: child.element,
                children: child.children,
                value: child.value,
                type: child.type,
              };
          headingText += getHeadingText(parsedHtmlChildProps);
        } else if (child.type === 'html') {
          const htmlChildProps = { type: child.type, value: child.value };
          headingText += getHeadingText(htmlChildProps);
        } else {
          const value =
            typeof child === 'string'
              ? child
              : (child.props && child.props.value) || child.value;
          const text = removeTriangleParentheses(value) || null;
          if (text) {
            headingText += text;
          }
        }
      });
    }
  } else if (
    props &&
    (props.type === 'parsedHtml' || props.type === 'html') &&
    props.value
  ) {
    headingText += removeHtmlFromTxt(props.value.trim());
  }
  return headingText;
};

export const getHeadingTextForId = (props) => {
  const headingText = getHeadingText(props);
  return toUrlFormat(removeSpecialChars(headingText));
};

export const getHeadingId = (props, markdownPath) => {
  const headingTextForId = getHeadingTextForId(props);
  return getMdHeadingId(markdownPath, props.id || headingTextForId);
};

const removeTriangleParentheses = (value) => {
  if (value && typeof value === 'string') {
    return value.replace(/(<|>)/g, '');
  }
  return value;
};

const getImgUrl = (imgUri) => {
  const mediaLocationRegRex = /(media|images)\//;
  return mediaLocationRegRex.test(imgUri)
    ? imgUri.split(mediaLocationRegRex).pop()
    : imgUri.split('/').pop();
};

export const transformImageUri = (store, location) => (imgUri) => {
  if (isAbsoluteUrl(imgUri)) {
    return imgUri;
  }
  const imgSrc = getImgUrl(imgUri);
  const { branch } = parseQueryString(location.search);

  if (branch) {
    return store.getEndpoint(`${branch}/docs/media/${imgSrc}`, location, true);
  } else {
    return store.getEndpoint(`docs/media/${imgSrc}`, location, true);
  }
};

export const getMarkdown = (markdown) => {
  if (typeof markdown !== 'string' && Array.isArray(markdown)) {
    let isAccumulatorInNotePart = false;
    return markdown.reduce((accm, next) => {
      /*
      A temporary logic for fixing markdown parsing issues related to blockquotes in Velo.
      See issue here: https://github.com/remarkjs/remark-gfm/issues/3
       */
      const fixNextWithBlockquote = () => {
        const isNextWithBlockquoteNotation = next.trimLeft().startsWith('>');
        const shouldAddBlockquoteNotationToNext =
          isAccumulatorInNotePart &&
          !isNextWithBlockquoteNotation &&
          next.trim().length > 0;
        isAccumulatorInNotePart =
          isNextWithBlockquoteNotation || shouldAddBlockquoteNotationToNext;
        return shouldAddBlockquoteNotationToNext ? `> ${next}` : next;
      };

      const fixedNext = fixNextWithBlockquote();
      return `${removeBreakingSpaces(accm)}\n${fixedNext}`;
    }, '');
  }
  return markdown;
};
